import React from 'react'
import './header.css'
import CTA from './CTA';
import ME from '../../assets/me-2.png'
import HeaderSocials from './HeaderSocials';
import { headline } from '../../data/profile';

const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Burak Sağ</h1>
        <h5 className="text-light">{headline}</h5>
        <CTA /> {/* Call To Action */}
        <HeaderSocials />

        <div className="me">
          <img src={ME} alt="Burak Sağ" />
        </div>
        <a href="#about" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
}

export default Header
